// Popup.js
import React from 'react';
import ReactDOM from 'react-dom';
import './RcbPopup.scss';

const RcbPopup = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  // Render the popup directly in the body
  return ReactDOM.createPortal(
    <div className="popup-overlay" onClick={onClose}>
      <div
        className="popup-content"
        onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside
      >
        <button className="popup-close" onClick={onClose}>
          &times;
        </button>
        {children}
      </div>
    </div>,
    document.body
  );
};

export default React.memo(RcbPopup);
